module.exports = __webpack_public_path__ + "img/PL08752.dd4f2444.png";